<template>
  <div>
    <div v-if="visible" class="mask" @click.self="onClose">
      <div class="panel">
        <div class="modal">
          <div class="modal-head">
            <div class="title-row">
              <img class="title-line" :src="titleL" alt="" />
              <span class="title">请选择其中一项奖品</span>
              <img class="title-line" :src="titleR" alt="" />
            </div>
          </div>

          <div class="modal-middle">
            <div
              v-for="item in prizeList"
              :key="item.goodsId"
              class="prize-item"
              :class="{ active: selectedId === item.goodsId }"
              @click="selectedId = item.goodsId"
            >
              <div class="prize-info">
                <p class="prize-name">{{ item.goodsName }}</p>
              </div>
              <div class="radio">
                <img
                  v-if="selectedId === item.goodsId"
                  class="check"
                  :src="checkIcon"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div class="modal-foot"></div>
        </div>

        <div class="submit" @click="onReceive">提交</div>
      </div>
    </div>

    <tip-dialog
      :visible="tipVisible"
      :message="tipMsg"
      :show-close="false"
      @close="onTipClose"
    />
  </div>
</template>

<script>
import { receivePrize } from '@/api/erkeAiStore'
import TipDialog from './TipDialog.vue'

export default {
  name: 'ErkeAiStoreSelectPrize',
  components: { TipDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 领取单 id
    receiveId: {
      type: [String, Number],
      default: ''
    },
    // [{ goodsId, goodsName }]
    goodsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedId: '',
      titleL: require('@/assets/img/erkeAiStore/modal-title-l.png'),
      titleR: require('@/assets/img/erkeAiStore/modal-title-r.png'),
      checkIcon: require('@/assets/img/erkeAiStore/modal-check.png'),
      loading: false,
      tipVisible: false,
      tipMsg: '',
      tipTimer: null
    }
  },
  computed: {
    prizeList() {
      return Array.isArray(this.goodsList) ? this.goodsList : []
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.selectedId = this.prizeList[0]?.goodsId || ''
        document.body.style.overflow = 'hidden'
      } else if (!this.tipVisible) {
        document.body.style.overflow = ''
      }
    }
  },
  beforeDestroy() {
    this.clearTipTimer()
    document.body.style.overflow = ''
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onTipClose() {
      this.clearTipTimer()
      this.tipVisible = false
      this.$emit('success')
    },
    clearTipTimer() {
      if (this.tipTimer) {
        clearTimeout(this.tipTimer)
        this.tipTimer = null
      }
    },
    async onReceive() {
      if (!this.selectedId) {
        this.$toast('请选择要领取的奖品')
        return
      }
      if (!this.receiveId) {
        this.$toast.fail('缺少领取单信息')
        return
      }
      if (this.loading) return
      try {
        this.loading = true
        const { code } = await receivePrize({
          id: this.receiveId,
          goodId: this.selectedId
        })
        this.loading = false
        if (code === 0) {
          this.$emit('close')
          this.tipMsg = '已成功领取奖品！'
          this.$nextTick(() => {
            this.tipVisible = true
            this.tipTimer = setTimeout(() => {
              this.onTipClose()
            }, 2000)
          })
        }
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mask {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 0 calc(24px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.panel {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.modal {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.modal-head {
  height: 106px;
  background: url('~@/assets/img/erkeAiStore/modal-head.png') center / 100%
    100% no-repeat;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 10px;
  box-sizing: border-box;

  .title-row {
    display: flex;
    align-items: center;
    justify-content: center;

    .title-line {
      width: 32px;
      height: 8px;
      display: block;
    }

    .title {
      margin: 0 8px;
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      line-height: 1;
      white-space: nowrap;
    }
  }
}

.modal-middle {
  background: url('~@/assets/img/erkeAiStore/modal-middle.png') center / 100%
    100% no-repeat;
  padding: 4px 48px 8px;
  box-sizing: border-box;
  min-height: 80px;
}

.modal-foot {
  height: 56px;
  background: url('~@/assets/img/erkeAiStore/modal-foot.png') center bottom /
    100% 100% no-repeat;
}

.prize-item {
  display: flex;
  align-items: center;
  min-height: 63px;
  margin-bottom: 15px;
  padding: 12px 16px 12px 24px;
  box-sizing: border-box;
  background: #180c07;
  border: 1px solid #fff;
  border-radius: 15px;

  &:last-child {
    margin-bottom: 0;
  }

  &.active {
    background: #200e08;
    box-shadow: 0 6px 33px 0 #e93100;
  }

  .prize-info {
    flex: 1;
    min-width: 0;

    .prize-name {
      margin: 0;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      line-height: 1.2;
    }
  }

  .radio {
    width: 21px;
    height: 21px;
    border-radius: 50%;
    border: 1px solid #fff;
    box-sizing: border-box;
    flex-shrink: 0;
    margin-left: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    .check {
      width: 11px;
      height: 8px;
      display: block;
    }
  }

  &.active .radio {
    background: linear-gradient(180deg, #fa3803 0%, #faa833 100%);
    border-color: #fff;
  }
}

.submit {
  width: 314px;
  max-width: calc(100% - 48px);
  height: 66px;
  flex-shrink: 0;
  margin-top: 4px;
  background: url('~@/assets/img/erkeAiStore/modal-submit.png') center / 100%
    100% no-repeat;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  line-height: 66px;
  text-align: center;
  padding: 0 36px;
  box-sizing: border-box;
}
</style>
